import { jsx as e } from "react/jsx-runtime";
const l = {
  "carousel-item": "_carousel-item_6p17l_29",
  "dialog-overlay-show": "_dialog-overlay-show_6p17l_1",
  "dialog-content-show": "_dialog-content-show_6p17l_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_6p17l_1"
};
function s({ children: o }) {
  return /* @__PURE__ */ e("div", { role: "listitem", className: l["carousel-item"], children: o });
}
export {
  s as CarouselItem
};
